import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Lamentamos que o artigo não tenha sido útil. Poderia nos informar o que estava errado?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Falta a informação que procuro',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Existem erros factuais',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Alguns pontos não estão claros',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Dê-nos alguns detalhes para que possamos melhorar este artigo.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Enviar'
    }
  }
};